/** admin role 가드 — admin 이 아니면 홈으로 리다이렉트. */

import { Navigate, Outlet } from "react-router-dom";

import { useAuthStore } from "@/features/auth/store";

export default function AdminGuard() {
  const role = useAuthStore((s) => s.user?.role);
  if (role !== "admin") {
    return <Navigate to="/" replace />;
  }
  return <Outlet />;
}
